import { Controller } from "@hotwired/stimulus";
import { jquery } from 'utils/jquery';

const PLUGIN_LOADED_EVENT = "multiple-select:loaded";

export default class extends Controller {
  static targets = ["select"];
  declare selectTarget: HTMLSelectElement;

  private onPluginLoaded: (() => void) | null = null;

  connect() {
    if (this.tryInitialize()) return;

    // The multiple_select plugin script (see app/assets/javascripts/multiple_select/index.js)
    // is included alongside this component's markup but loads asynchronously — it can (and in
    // practice does, especially on an uncompiled dev asset) finish loading *after* this
    // controller has already connected. Rather than giving up for good, wait for the
    // load-complete event the asset itself dispatches once `$.fn.multipleSelect` exists.
    console.warn(`[MultipleSelectComponent] multipleSelect plugin not loaded yet — waiting for '${PLUGIN_LOADED_EVENT}'.`);
    this.onPluginLoaded = () => this.tryInitialize();
    document.addEventListener(PLUGIN_LOADED_EVENT, this.onPluginLoaded);
  }

  disconnect() {
    if (this.onPluginLoaded) {
      document.removeEventListener(PLUGIN_LOADED_EVENT, this.onPluginLoaded);
      this.onPluginLoaded = null;
    }
  }

  private tryInitialize(): boolean {
    const $ = jquery();
    if (!$ || typeof $.fn.multipleSelect !== 'function') return false;

    $(this.selectTarget).multipleSelect({
      allSelected: true,
      selectAll: true,
      formatAllSelected: () => 'All',
      formatSelectAll: () => 'Select All / None',
      maxHeight: '600',
      placeholder: 'State'
    });

    if (this.onPluginLoaded) {
      document.removeEventListener(PLUGIN_LOADED_EVENT, this.onPluginLoaded);
      this.onPluginLoaded = null;
    }

    return true;
  }
}
